import { useAppSelector } from '@/redux/store';
import { getCookies, getRole } from '@/utility/helper';
import { getRolePrefix } from '@/utility/RouteLinks';
import { IRole } from '@/interfaces/Auth/auth.interface';

interface UseActiveRoleReturn {
  activeRole: IRole | undefined;
  prefix: string;
  roleName: string;
  roleId: string;
  rolesMap?: Record<string, IRole>;
}

export const useActiveRole = (): UseActiveRoleReturn => {
  const rolesMap = useAppSelector((state) => state.user.role);
  const userRoleId = getCookies(`${import.meta.env.VITE_BUSINESS}role`);
  const activeRole = getRole(rolesMap, userRoleId);
  const prefix = getRolePrefix(activeRole?.name ?? '');
  // console.log("roleId", userRoleId);

  return {
    activeRole,
    prefix,
    roleName: activeRole?.name ?? '',
    roleId: activeRole?.id ?? '',
    rolesMap: rolesMap
  };
};
